import orderService from './../../../services/order';
import Vue from 'vue';
import Icon from 'vue-awesome';
import orderState from '@/utils/orderState';
import moment from 'moment';
import store from '@/store';
import { encodePathSegment } from '@/utils/url';

const getImageUrl = hash =>
  `${process.env.API_LOCATION}api/Containers/${process.env.GS_BUCKET}/download/${encodePathSegment(hash)}?access_token=${encodeURIComponent(
    store.state.auth.token,
  )}`;

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue'),
    Icon,
    orderForm: require('@/components/orderForm/orderForm.vue'),
  },
  data() {
    return {
      form: {
        orderNum: '',
        orderDate: new Date(),
        items: [
          {
            refCode: '',
            title: '',
            description: '',
            quantity: 1,
            price: '',
            discountable: false,
            totalPrice: '',
          },
        ],
        images: [],
        deliveryType: null,
        deliveryPrice: 0,
        tax: 0,
        setupPrice: 0,
        deliveryAddress: '',
        deliveryPhoneNumber: '',
        deliveryDate: new Date(),
        deliveryTime: [],
        discount: 0,
        totalDiscount: 0,
        totalPrice: 0,
        customerId: null,
      },
      notPaid: true,
      fileList: [],
    };
  },
  mounted() {
    this.fetchOrder();
  },
  computed: {},
  props: ['id'],
  methods: {
    async fetchOrder() {
      const product = await orderService.getOne(this.id, {
        filter: {
          include: 'orderItem',
        },
      });
      product.items = product.orderItem.map((x) => {
        x.price = x.unitPrice;
        return x;
      });
      product.tax = parseFloat(product.tax);
      product.bypassTax = product.bypassTax === 1;

      if (typeof product.deliveryTime === 'string') {
        product.deliveryTime = [];
      }

      product.deliveryTime = [
        moment(product.deliveryTimeStart).format('HH:mm'),
        moment(product.deliveryTimeEnd).format('HH:mm'),
      ];

      if (!product.images) {
        product.images = [];
      } else {
        // generate fileList
        const newDataImages = [];

        for (const v of product.images) {
          this.fileList.push({
            url: getImageUrl(v),
            filename: v,
          });
          newDataImages.push(v);
        }
        product.images = newDataImages;
      }

      if (orderState.get('paid').is(product.orderState)) {
        this.notPaid = false;
      }

      this.form = product;
    },
    async onSubmit(form) {
      try {
        if (form.deliveryTime[0]) {
          form.deliveryTimeStart = moment(form.deliveryTime[0], 'HH:mm').toDate();
        }

        if (form.deliveryTime[1]) {
          form.deliveryTimeEnd = moment(form.deliveryTime[1], 'HH:mm').toDate();
        }

        const response = await orderService.edit(form);
        if (response.data.error) {
          this.$message.error(response.data.error.message);
        } else {
          Vue.router.push({
            name: 'order.view',
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/order/edit/index.js